// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CoverRepositionController from "./cover_reposition_controller"
application.register("cover-reposition", CoverRepositionController)

import DevicePreviewController from "./device_preview_controller"
application.register("device-preview", DevicePreviewController)

import DropFileController from "./drop_file_controller"
application.register("drop-file", DropFileController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import FilterDrawerController from "./filter_drawer_controller"
application.register("filter-drawer", FilterDrawerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import NavToggleController from "./nav_toggle_controller"
application.register("nav-toggle", NavToggleController)

import NestedRowsController from "./nested_rows_controller"
application.register("nested-rows", NestedRowsController)

import OnlineIndicatorController from "./online_indicator_controller"
application.register("online-indicator", OnlineIndicatorController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import PresenceController from "./presence_controller"
application.register("presence", PresenceController)

import PreviewFrameController from "./preview_frame_controller"
application.register("preview-frame", PreviewFrameController)

import SectionTabsController from "./section_tabs_controller"
application.register("section-tabs", SectionTabsController)

import SubmitShortcutController from "./submit_shortcut_controller"
application.register("submit-shortcut", SubmitShortcutController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
